import { createTheme } from "@mui/material";

// declare module "@mui/material/styles" {
// 	interface Theme {
// 		status: {
// 			success: object;
// 			warning: object;
// 		};
// 		customColor: {
// 			secondary: object;
// 		};
// 	}
// 	interface ThemeOptions {
// 		status?: {
// 			success?: object;
// 			warning?: object;
// 		};
// 		customColor: {
// 			secondary: object;
// 		};
// 	}
// }

// primary => yello bg
// secondary => white bg

const theme = createTheme({
  status: {
    success: {
      color: "rgba(84, 214, 44, 0.16)",
      textContrast: "rgb(34, 154, 22)",
    },
    warning: {
      color: "rgba(255, 193, 7, 0.16)",
      textContrast: "rgb(183, 129, 3)",
    },
  },
  customColor: {
    secondary: {
      color: "rgba(0, 0, 0, 0.53)",
    },
  },
  palette: {
    primary: {
      light: "#FFCD00",
      main: "#FFCD00",
      dark: "#FFCD00",
      contrastText: "#520A76",
    },
    secondary: {
      light: "#FFFFFF",
      main: "#FFFFFF",
      dark: "#FFFFFF",
      contrastText: "#520A76;",
    },
    success: {
      main: "rgb(34, 154, 22)",
      light: "rgba(84, 214, 44, 0.16)",
      dark: "#1b5e20",
      // contrastText: "rgb(34, 154, 22)",
    },
    warning: {
      main: "rgb(183, 129, 3)",
      light: "rgba(255, 193, 7, 0.16)",
      dark: "#e65100",
      // contrastText: "rgb(183, 129, 3)"
    },
    error: {
      main: "rgb(183, 33, 54)",
      light: "rgba(255, 72, 66, 0.16)",
      dark: "#c62828",
      // contrastText: "rgb(183, 33, 54)",
    },
    info: {
      main: "#520A76",
      light: "#520A76",
      dark: "#520A76",
      contrastText: "#FFFFFF",
    },
  },
  typography: {
    fontFamily: "arabic",
  },
});

export default theme;
